import { classNames, isStatusPreGame } from '@library/utils';
import type { Status } from '@library/types/projection';

export interface TenGameAverageProps {
  statType: string;
  status?: Status;
  tenGameAvg?: number;
}

export const TenGameAverage = ({
  statType,
  status = undefined,
  tenGameAvg = undefined
}: TenGameAverageProps) => {
  return (
    <td
      className={classNames(
        'py-4 text-center',
        !isStatusPreGame(status) ? 'opacity-50' : ''
      )}
      key={`${statType} Avg`}
    >
      {tenGameAvg ?? 'N/A'}
    </td>
  );
};
